import { useMediaQuery } from '@mui/material';

/**
 * True when the viewport is narrower than Tailwind's `md` breakpoint (768px).
 *
 * Drives the shell's mobile-vs-desktop split (hamburger drawer instead of
 * inline sidebar, simplified breadcrumbs, tighter padding). The raw query
 * string is used deliberately — MUI's default `md` is 900px and Tailwind's
 * is 768px, so reaching for `theme.breakpoints.down('md')` would put JS
 * branches out of sync with `md:` semantic classes. Keep them aligned.
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767.95px)');
}
